import { cardsData } from '@/mocks/homepage';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            编辑精选
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            深度漫画推荐与专题盘点，帮你发现更多好作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.map((card) => (
            <a
              key={card.id}
              href="#index"
              className="group block bg-background-100 rounded-xl overflow-hidden transition-transform duration-300 hover:-translate-y-1 cursor-pointer no-underline"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-[11px] font-medium whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-medium text-sm md:text-base text-foreground-900 mb-2 line-clamp-2 leading-snug">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {card.desc}
                </p>
                <span className="text-xs text-foreground-400">
                  {card.date}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}